import { render, staticRenderFns } from "./_integrationPanel.vue?vue&type=template&id=f56d53f6&scoped=true&"
import script from "./_integrationPanel.vue?vue&type=script&lang=js&"
export * from "./_integrationPanel.vue?vue&type=script&lang=js&"
import style0 from "./_integrationPanel.vue?vue&type=style&index=0&id=f56d53f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d53f6",
  null
  
)

export default component.exports